import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import BankData from "../json/bank-data.json"
import i18n from '@/plugins/vue-i18n';
import Vue from "vue";

export class ExportAccounting {
  constructor() {
    // excel file type
  }
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }
  static numberToLetters(num) {
    let letters = ''
    while (num >= 0) {
      letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[num % 26] + letters
      num = Math.floor(num / 26) - 1
    }
    return letters
  }
  static async exportInvoiceList(_invoices, startDate, endDate, monthYear, vatPercent) {
    const workbook = new exceljs.Workbook();
    const currencySupports = Vue.prototype.$globalCurrencySupports
    for (let currencyCode of currencySupports) {
      const invoices = _invoices.filter(d => d.currencyCode == currencyCode)
      const worksheet = workbook.addWorksheet(currencyCode);
  
      let hashAccountingProductTax7 = {}
      let hashAccountingProductTax0 = {}
      let hashAccountingProductTaxx = {}
  
  
      for (let invoice of invoices) {
        for (let item of invoice.items) {
          if (item.accountingProduct && item.totalNonVatValue) {
            let accId = item.accountingProduct.objectId
  
            if (item.sellVatType == 1 && !hashAccountingProductTax7[`1_${accId}`])
              hashAccountingProductTax7[`1_${accId}`] = item.accountingProduct
  
            if (item.sellVatType == 2 && !hashAccountingProductTax0[`2_${accId}`])
              hashAccountingProductTax0[`2_${accId}`] = item.accountingProduct
  
            if (item.sellVatType == 3 && !hashAccountingProductTaxx[`3_${accId}`])
              hashAccountingProductTaxx[`3_${accId}`] = item.accountingProduct
          }
        }
      }
  
      let columns = [
        {
          header: i18n.t('rank'),
          key: 1,
          width: 15,
          style: {
            alignment: {
              horizontal: "center",
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('market.market'),
          key: 2,
          width: 25,
          style: {
            alignment: {
              horizontal: "center",
              vertical: "center"
            }
          }
        },
        {
          header: `${i18n.t('day')} / ${i18n.t('month')} / ${i18n.t('year')}`,
          key: 3,
          width: 25,
          style: {
            alignment: {
              horizontal: "center",
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('market.document_id'),
          key: 4,
          width: 25,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('customer.customer_name'),
          key: 5,
          width: 30,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('bill.business_name'),
          key: 6,
          width: 30,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('market.market_title'),
          key: 7,
          width: 30,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('accounting_product.type_of_list'),
          key: 8,
          width: 20,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('tax.tax_id_number'),
          key: 9,
          width: 30,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('market.big_office_or_branch'),
          key: 10,
          width: 20,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
      ]
  
      let hashAccountingProductZero = {}
      let arrCode1 = {}
      let arrCode2 = {}
      let arrCode3 = {}
      arrCode1[10] = i18n.t('account.accounting_code_1')
      arrCode2[10] = i18n.t('account.accounting_code_2')
      arrCode3[10] = i18n.t('account.accounting_code_3')
      for (let key in { ...hashAccountingProductTax0, ...hashAccountingProductTaxx, ...hashAccountingProductTax7 }) {
        columns.push({
          header: { ...hashAccountingProductTax0, ...hashAccountingProductTaxx, ...hashAccountingProductTax7 }[key].name,
          key: key,
          width: 25,
          style: {
            alignment: {
              horizontal: "right",
              vertical: "center"
            }
          }
        })
        hashAccountingProductZero[key] = 0
        let code1 = { ...hashAccountingProductTax0, ...hashAccountingProductTaxx, ...hashAccountingProductTax7 }[key].code
        let code2 = { ...hashAccountingProductTax0, ...hashAccountingProductTaxx, ...hashAccountingProductTax7 }[key].code2
        let code3 = { ...hashAccountingProductTax0, ...hashAccountingProductTaxx, ...hashAccountingProductTax7 }[key].code3
        arrCode1[key] = code1
        arrCode2[key] = code2
        arrCode3[key] = code3
      }
  
      columns = [...columns,
      {
        header: i18n.t('product.product_value_or_service_zero_percent'),
        key: 11,
        width: 25,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('product.product_value_or_service_except'),
        key: 12,
        width: 25,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('product.product_value_or_service_percent', { count: vatPercent ? vatPercent : 0 }),
        key: 13,
        width: 25,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: `${i18n.t('tax.tax_vat')} (${vatPercent ? vatPercent : 0}%)`,
        key: 14,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('sum'),
        key: 15,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('status'),
        key: 16,
        width: 20,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      ]
  
      worksheet.columns = columns
      let header = {}
      if (Object.keys(hashAccountingProductTax0)[0]) {
        header[Object.keys(hashAccountingProductTax0)[0]] = i18n.t('product.product_value_or_service_zero_percent')
      }
      if (Object.keys(hashAccountingProductTaxx)[0]) {
        header[Object.keys(hashAccountingProductTaxx)[0]] = i18n.t('product.product_value_or_service_except')
      }
      if (Object.keys(hashAccountingProductTax7)[0]) {
        header[Object.keys(hashAccountingProductTax7)[0]] = i18n.t('product.product_value_or_service_percent', { count: vatPercent })
      }
      worksheet.spliceRows(1, 0, header)
      worksheet.spliceRows(2, 0, arrCode1)
      worksheet.spliceRows(3, 0, arrCode2)
      worksheet.spliceRows(4, 0, arrCode3)
      worksheet.getRow(1).alignment = {
        vertical: 'center',
        horizontal: 'center'
      }
      worksheet.getRow(2).alignment = {
        vertical: 'center',
        horizontal: 'right'
      }
      worksheet.getRow(3).alignment = {
        vertical: 'center',
        horizontal: 'right'
      }
      worksheet.getRow(4).alignment = {
        vertical: 'center',
        horizontal: 'right'
      }
  
  
      let startCol = 10
      if (Object.keys(hashAccountingProductTax0)[0]) {
        worksheet.mergeCells(`${this.numberToLetters(startCol)}1:${this.numberToLetters(startCol + Object.keys(hashAccountingProductTax0).length - 1)}1`);
        startCol += Object.keys(hashAccountingProductTax0).length
      }
      if (Object.keys(hashAccountingProductTaxx)[0]) {
        worksheet.mergeCells(`${this.numberToLetters(startCol)}1:${this.numberToLetters(startCol + Object.keys(hashAccountingProductTaxx).length - 1)}1`);
        startCol += Object.keys(hashAccountingProductTaxx).length
      }
      if (Object.keys(hashAccountingProductTax7)[0]) {
        worksheet.mergeCells(`${this.numberToLetters(startCol)}1:${this.numberToLetters(startCol + Object.keys(hashAccountingProductTax7).length - 1)}1`);
        startCol += Object.keys(hashAccountingProductTax7).length
      }
  
      let totalAllTax0 = 0
      let totalAllTaxx = 0
      let totalAllTax7 = 0
      let totalAllVatValue = 0
      let totalAllValue = 0
  
      let hashItemTotalAllValueTax7 = {}
      let hashItemTotalAllValueTax0 = {}
      let hashItemTotalAllValueTaxx = {}
  
      let index = 1
      for (let invoice of invoices) {
        let totalTax0 = invoice.items.filter(d => d.sellVatType == 2).reduce((a, b) => a + (b.totalValue || 0), 0)
        let totalTaxx = invoice.items.filter(d => d.sellVatType == 3).reduce((a, b) => a + (b.totalValue || 0), 0)
        let totalTax7 = invoice.items.filter(d => d.sellVatType == 1).reduce((a, b) => a + (b.totalValue || 0), 0)
  
        let hashItemTotalValueTax7 = {}
        let hashItemTotalValueTax0 = {}
        let hashItemTotalValueTaxx = {}
  
        totalAllTax0 += totalTax0 || 0
        totalAllTaxx += totalTaxx || 0
        totalAllTax7 += totalTax7 || 0
        totalAllVatValue += invoice.totalVatValue || 0
        totalAllValue += invoice.totalValue || 0
  
        for (let item of invoice.items) {
          if (item.accountingProduct && item.totalNonVatValue) {
            let accId = item.accountingProduct.objectId
            if (item.sellVatType == 1) {
              if (!hashItemTotalValueTax7[`1_${accId}`]) hashItemTotalValueTax7[`1_${accId}`] = 0
              hashItemTotalValueTax7[`1_${accId}`] += item.totalNonVatValue || 0
  
              if (!hashItemTotalAllValueTax7[`1_${accId}`]) hashItemTotalAllValueTax7[`1_${accId}`] = 0
              hashItemTotalAllValueTax7[`1_${accId}`] += item.totalNonVatValue || 0
            }
            if (item.sellVatType == 2) {
              if (!hashItemTotalValueTax0[`2_${accId}`]) hashItemTotalValueTax0[`2_${accId}`] = 0
              hashItemTotalValueTax0[`2_${accId}`] += item.totalNonVatValue || 0
  
              if (!hashItemTotalAllValueTax0[`2_${accId}`]) hashItemTotalAllValueTax0[`2_${accId}`] = 0
              hashItemTotalAllValueTax0[`2_${accId}`] += item.totalNonVatValue || 0
            }
            if (item.sellVatType == 3) {
              if (!hashItemTotalValueTaxx[`3_${accId}`]) hashItemTotalValueTaxx[`3_${accId}`] = 0
              hashItemTotalValueTaxx[`3_${accId}`] += item.totalNonVatValue || 0
  
              if (!hashItemTotalAllValueTaxx[`3_${accId}`]) hashItemTotalAllValueTaxx[`3_${accId}`] = 0
              hashItemTotalAllValueTaxx[`3_${accId}`] += item.totalNonVatValue || 0
            }
          }
        }
        worksheet.addRow({
          1: index,
          2: invoice.market.name || "",
          3: invoice.date ? new Date(moment(invoice.date).format("YYYY-MM-DD")) : "",
          4: invoice.documentId,
          5: invoice.customerData.name || "",
          6: invoice.businessName || "",
          7: invoice.areaName || "",
          8: invoice.documentTypeString || "",
          9: invoice.customerData.taxId || "",
          10: invoice.customerData.branchName || "",
          11: totalTax0 || 0,
          12: totalTaxx || 0,
          13: totalTax7 || 0,
          14: invoice.totalVatValue || 0,
          15: invoice.totalValue || 0,
          16: invoice.status || "",
          ...hashAccountingProductZero,
          ...hashItemTotalValueTax7,
          ...hashItemTotalValueTax0,
          ...hashItemTotalValueTaxx
        })
        index++
      }
  
      worksheet.addRow({
        1: i18n.t('sum'),
        11: totalAllTax0 || 0,
        12: totalAllTaxx || 0,
        13: totalAllTax7 || 0,
        14: totalAllVatValue || 0,
        15: totalAllValue || 0,
        ...hashItemTotalAllValueTax7,
        ...hashItemTotalAllValueTax0,
        ...hashItemTotalAllValueTaxx
      })
      worksheet.mergeCells(`A${index + 5}:J${index + 5}`);
      worksheet.getRow(index + 5).font = { bold: true };
    }
    if (monthYear) {
      return this.saveFile(workbook, `invoices-${monthYear}`);
    } else {
      return this.saveFile(workbook, `invoicelist-${moment(startDate).format("D-M-YYYY")}-to-${moment(endDate).format("D-M-YYYY")}`);
    }
  }

  static async exportReceiptList(_receipts, startDate, endDate, paymentMethodType, vatPercent) {
    const workbook = new exceljs.Workbook();
    const currencySupports = Vue.prototype.$globalCurrencySupports
    for (let currencyCode of currencySupports) {
      const receipts = _receipts.filter(d => d.currencyCode == currencyCode)
      const worksheet = workbook.addWorksheet(currencyCode);

      let hashAccountingProductTax7 = {}
      let hashAccountingProductTax0 = {}
      let hashAccountingProductTaxx = {}
  
  
      for (let receipt of receipts) {
        for (let item of receipt.items) {
          if (item.accountingProduct && item.totalNonVatValue) {
            let accId = item.accountingProduct.objectId
  
            if (item.sellVatType == 1 && !hashAccountingProductTax7[`1_${accId}`])
              hashAccountingProductTax7[`1_${accId}`] = item.accountingProduct
  
            if (item.sellVatType == 2 && !hashAccountingProductTax0[`2_${accId}`])
              hashAccountingProductTax0[`2_${accId}`] = item.accountingProduct
  
            if (item.sellVatType == 3 && !hashAccountingProductTaxx[`3_${accId}`])
              hashAccountingProductTaxx[`3_${accId}`] = item.accountingProduct
          }
        }
      }
  
      let columns = [
        {
          header: i18n.t('rank'),
          key: 1,
          width: 15,
          style: {
            alignment: {
              horizontal: "center",
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('market.market'),
          key: 2,
          width: 25,
          style: {
            alignment: {
              horizontal: "center",
              vertical: "center"
            }
          }
        },
        {
          header: `${i18n.t('day')} / ${i18n.t('month')} / ${i18n.t('year')}`,
          key: 3,
          width: 25,
          style: {
            alignment: {
              horizontal: "center",
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('market.document_id'),
          key: 4,
          width: 25,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('accounting_product.type_of_list'),
          key: 5,
          width: 20,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('operator'),
          key: 6,
          width: 20,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('customer.customer_name'),
          key: 7,
          width: 30,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('bill.business_name'),
          key: 8,
          width: 30,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('market.market_title'),
          key: 9,
          width: 30,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('tax.tax_id_number'),
          key: 10,
          width: 30,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('market.big_office_or_branch'),
          key: 11,
          width: 20,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
      ]
  
      let hashAccountingProductZero = {}
      let arrCode1 = {}
      let arrCode2 = {}
      let arrCode3 = {}
      arrCode1[11] = i18n.t('account.accounting_code_1')
      arrCode2[11] = i18n.t('account.accounting_code_2')
      arrCode3[11] = i18n.t('account.accounting_code_3')
      for (let key in { ...hashAccountingProductTax0, ...hashAccountingProductTaxx, ...hashAccountingProductTax7 }) {
        columns.push({
          header: { ...hashAccountingProductTax0, ...hashAccountingProductTaxx, ...hashAccountingProductTax7 }[key].name,
          key: key,
          width: 25,
          style: {
            alignment: {
              horizontal: "right",
              vertical: "center"
            }
          }
        })
        hashAccountingProductZero[key] = 0
        let code1 = { ...hashAccountingProductTax0, ...hashAccountingProductTaxx, ...hashAccountingProductTax7 }[key].code
        let code2 = { ...hashAccountingProductTax0, ...hashAccountingProductTaxx, ...hashAccountingProductTax7 }[key].code2
        let code3 = { ...hashAccountingProductTax0, ...hashAccountingProductTaxx, ...hashAccountingProductTax7 }[key].code3
        arrCode1[key] = code1
        arrCode2[key] = code2
        arrCode3[key] = code3
      }
  
      columns = [...columns,
      {
        header: i18n.t('product.product_value_or_service_zero_percent'),
        key: 12,
        width: 25,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('product.product_value_or_service_except'),
        key: 13,
        width: 25,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('product.product_value_or_service_percent', { count: vatPercent ? vatPercent : 0 }),
        key: 14,
        width: 25,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: `${i18n.t('tax.tax_vat')} (${vatPercent ? vatPercent : 0}%)`,
        key: 15,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('sum'),
        key: 16,
        width: 20,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('status'),
        key: 17,
        width: 20,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.payment_method_money'),
        key: 18,
        width: 20,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.payment_account_number'),
        key: 19,
        width: 20,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.bank_name_that_pay'),
        key: 20,
        width: 20,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      }
      ]
  
      worksheet.columns = columns
      let header = {}
      if (Object.keys(hashAccountingProductTax0)[0]) {
        header[Object.keys(hashAccountingProductTax0)[0]] = i18n.t('product.product_value_or_service_zero_percent')
      }
      if (Object.keys(hashAccountingProductTaxx)[0]) {
        header[Object.keys(hashAccountingProductTaxx)[0]] = i18n.t('product.product_value_or_service_except')
      }
      if (Object.keys(hashAccountingProductTax7)[0]) {
        header[Object.keys(hashAccountingProductTax7)[0]] = i18n.t('product.product_value_or_service_percent', { count: vatPercent })
      }
  
      worksheet.spliceRows(1, 0, header)
      worksheet.spliceRows(2, 0, arrCode1)
      worksheet.spliceRows(3, 0, arrCode2)
      worksheet.spliceRows(4, 0, arrCode3)
      worksheet.getRow(1).alignment = {
        vertical: 'center',
        horizontal: 'center'
      }
      worksheet.getRow(2).alignment = {
        vertical: 'center',
        horizontal: 'right'
      }
      worksheet.getRow(3).alignment = {
        vertical: 'center',
        horizontal: 'right'
      }
      worksheet.getRow(4).alignment = {
        vertical: 'center',
        horizontal: 'right'
      }
  
      let startCol = 11
      if (Object.keys(hashAccountingProductTax0)[0]) {
        worksheet.mergeCells(`${this.numberToLetters(startCol)}1:${this.numberToLetters(startCol + Object.keys(hashAccountingProductTax0).length - 1)}1`);
        startCol += Object.keys(hashAccountingProductTax0).length
      }
      if (Object.keys(hashAccountingProductTaxx)[0]) {
        worksheet.mergeCells(`${this.numberToLetters(startCol)}1:${this.numberToLetters(startCol + Object.keys(hashAccountingProductTaxx).length - 1)}1`);
        startCol += Object.keys(hashAccountingProductTaxx).length
      }
      if (Object.keys(hashAccountingProductTax7)[0]) {
        worksheet.mergeCells(`${this.numberToLetters(startCol)}1:${this.numberToLetters(startCol + Object.keys(hashAccountingProductTax7).length - 1)}1`);
        startCol += Object.keys(hashAccountingProductTax7).length
      }
  
      let totalAllTax0 = 0
      let totalAllTaxx = 0
      let totalAllTax7 = 0
      let totalAllVatValue = 0
      let totalAllValue = 0
  
      let hashItemTotalAllValueTax7 = {}
      let hashItemTotalAllValueTax0 = {}
      let hashItemTotalAllValueTaxx = {}
  
      const paymentMethods = {
        1: i18n.t('payment.methods.1'),
        2: i18n.t('payment.methods.2'),
        3: i18n.t('payment.methods.3'),
        4: i18n.t('payment.methods.4'),
        5: i18n.t('payment.methods.5'),
        6: i18n.t('payment.methods.6'),
        7: i18n.t('payment.methods.7'),
        8: i18n.t('payment.methods.8')
      };
      let index = 1
      for (let receipt of receipts) {
        let totalTax0 = receipt.items.filter(d => d.sellVatType == 2).reduce((a, b) => a + (b.totalValue || 0), 0)
        let totalTaxx = receipt.items.filter(d => d.sellVatType == 3).reduce((a, b) => a + (b.totalValue || 0), 0)
        let totalTax7 = receipt.items.filter(d => d.sellVatType == 1).reduce((a, b) => a + (b.totalValue || 0), 0)
  
        let hashItemTotalValueTax7 = {}
        let hashItemTotalValueTax0 = {}
        let hashItemTotalValueTaxx = {}
  
        totalAllTax0 += totalTax0 || 0
        totalAllTaxx += totalTaxx || 0
        totalAllTax7 += totalTax7 || 0
        totalAllVatValue += receipt.totalVatValue || 0
        totalAllValue += receipt.totalValue || 0
  
        for (let item of receipt.items) {
          if (item.accountingProduct && item.totalNonVatValue) {
            let accId = item.accountingProduct.objectId
            if (item.sellVatType == 1) {
              if (!hashItemTotalValueTax7[`1_${accId}`]) hashItemTotalValueTax7[`1_${accId}`] = 0
              hashItemTotalValueTax7[`1_${accId}`] += item.totalNonVatValue || 0
  
              if (!hashItemTotalAllValueTax7[`1_${accId}`]) hashItemTotalAllValueTax7[`1_${accId}`] = 0
              hashItemTotalAllValueTax7[`1_${accId}`] += item.totalNonVatValue || 0
            }
            if (item.sellVatType == 2) {
              if (!hashItemTotalValueTax0[`2_${accId}`]) hashItemTotalValueTax0[`2_${accId}`] = 0
              hashItemTotalValueTax0[`2_${accId}`] += item.totalNonVatValue || 0
  
              if (!hashItemTotalAllValueTax0[`2_${accId}`]) hashItemTotalAllValueTax0[`2_${accId}`] = 0
              hashItemTotalAllValueTax0[`2_${accId}`] += item.totalNonVatValue || 0
            }
            if (item.sellVatType == 3) {
              if (!hashItemTotalValueTaxx[`3_${accId}`]) hashItemTotalValueTaxx[`3_${accId}`] = 0
              hashItemTotalValueTaxx[`3_${accId}`] += item.totalNonVatValue || 0
  
              if (!hashItemTotalAllValueTaxx[`3_${accId}`]) hashItemTotalAllValueTaxx[`3_${accId}`] = 0
              hashItemTotalAllValueTaxx[`3_${accId}`] += item.totalNonVatValue || 0
            }
          }
        }
        worksheet.addRow({
          1: index,
          2: receipt.market.name || "",
          3: receipt.date ? new Date(moment(receipt.date).format("YYYY-MM-DD")) : "",
          4: receipt.documentId,
          5: receipt.documentTypeString || "",
          6: receipt.createdByText || "",
          7: receipt.customerData.name || "",
          8: receipt.businessName || "",
          9: receipt.areaName || "",
          10: receipt.customerData.taxId || "",
          11: receipt.customerData.branchName || "",
          12: totalTax0 || 0,
          13: totalTaxx || 0,
          14: totalTax7 || 0,
          15: receipt.totalVatValue || 0,
          16: receipt.totalValue || 0,
          17: receipt.status || "",
          18: receipt.paymentMethod ? paymentMethods[receipt.paymentMethod] : '' || "",
          19: receipt.paymentBankAccount ? receipt.paymentBankAccount.accountNumber : '' || "",
          20: receipt.paymentBankAccount && receipt.paymentBankAccount.bankCode ? BankData[receipt.paymentBankAccount.bankCode].name : '' || "",
          ...hashAccountingProductZero,
          ...hashItemTotalValueTax7,
          ...hashItemTotalValueTax0,
          ...hashItemTotalValueTaxx
        })
        index++
      }
  
      worksheet.addRow({
        1: i18n.t('sum'),
        12: totalAllTax0 || 0,
        13: totalAllTaxx || 0,
        14: totalAllTax7 || 0,
        15: totalAllVatValue || 0,
        16: totalAllValue || 0,
        ...hashItemTotalAllValueTax7,
        ...hashItemTotalAllValueTax0,
        ...hashItemTotalAllValueTaxx
      })
      worksheet.mergeCells(`A${index + 5}:J${index + 5}`);
      worksheet.getRow(index + 5).font = { bold: true };
  
      if (paymentMethodType?.[currencyCode]) {
        for (const indexHeader in paymentMethodType?.[currencyCode]) {
          let itemHeader = paymentMethodType?.[currencyCode][indexHeader]
          worksheet.addRow({
            1: indexHeader,
            2: itemHeader.sum
          })
          index++
          worksheet.mergeCells(`B${index + 5}:D${index + 5}`);
          worksheet.getRow(index + 5).font = { bold: true, color: { argb: indexHeader == i18n.t('payment.paid') ? "FF4CAF50" : "FFF44336" } };
          worksheet.getRow(index + 5).alignment = {
            vertical: 'center',
            horizontal: 'right'
          }
          for (const indexItem in itemHeader.data) {
            let item = itemHeader.data[indexItem]
            worksheet.addRow({
              1: '',
              2: indexItem,
              3: item.sum
            })
            index++
            worksheet.mergeCells(`C${index + 5}:D${index + 5}`);
            worksheet.getRow(index + 5).alignment = {
              vertical: 'center',
              horizontal: 'right'
            }
            for (const indexDetail in item.type) {
              let itemDetail = item.type[indexDetail]
              if (itemDetail.data) {
                worksheet.addRow({
                  1: '',
                  2: '',
                  3: `${i18n.t('payment.account_receipt')} ${BankData[itemDetail.data.bankCode].name} (${indexDetail})`,
                  4: itemDetail.sum
                })
              } else {
                worksheet.addRow({
                  1: '',
                  2: '',
                  3: `${i18n.t('payment.received_by')} ` + indexDetail,
                  4: itemDetail.sum
                })
              }
              index++
            }
          }
        }
      }
    }
    return this.saveFile(workbook, `receiptlist-${moment(startDate).format("D-M-YYYY")}-to-${moment(endDate).format("D-M-YYYY")}`);
  }

  static async exportCreditNoteList(_creditNotes, startDate, endDate, monthYear) {
    const workbook = new exceljs.Workbook();
    const currencySupports = Vue.prototype.$globalCurrencySupports
    for (let currencyCode of currencySupports) {
      const creditNotes = _creditNotes.filter(d => d.currencyCode == currencyCode)
      const worksheet = workbook.addWorksheet(currencyCode);
      worksheet.columns  = [
        {
          header: i18n.t('rank'),
          key: 1,
          width: 15,
          style: {
            alignment: {
              horizontal: "center",
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('market.market'),
          key: 2,
          width: 25,
          style: {
            alignment: {
              horizontal: "center",
              vertical: "center"
            }
          }
        },
        {
          header: `${i18n.t('day')} / ${i18n.t('month')} / ${i18n.t('year')}`,
          key: 3,
          width: 25,
          style: {
            alignment: {
              horizontal: "center",
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('market.document_id'),
          key: 4,
          width: 25,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('invoice.title'),
          key: 5,
          width: 25,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('market.checkout'),
          key: 6,
          width: 25,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('market.market_title'),
          key: 7,
          width: 30,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('bill.customer_market_id'),
          key: 8,
          width: 25,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('customer.customer_name'),
          key: 9,
          width: 30,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('bill.business_name'),
          key: 10,
          width: 30,
          style: {
            alignment: {
              vertical: "center"
            }
          }
        },
        {
          header: i18n.t('market.total_value'),
          key: 11,
          width: 20,
          style: {
            alignment: {
              horizontal: "right",
              vertical: "center"
            }
          }
        },
      ]
  
      let index = 1
      for (let creditNote of creditNotes) {
        worksheet.addRow({
          1: index,
          2: creditNote.market.name || "",
          3: creditNote.date ? new Date(moment(creditNote.date).format("YYYY-MM-DD")) : "",
          4: creditNote.documentId,
          5: creditNote.invoiceId,
          6: creditNote.contractCheckoutId,
          7: creditNote.areaName || "",
          8: creditNote.contractCustomerMarketId || "",
          9: creditNote.customerDataName || "",
          10: creditNote.businessName || "",
          11: creditNote.totalValue || 0,
        })
        index++
      }
    }

    if (monthYear) {
      return this.saveFile(workbook, `creditnote-${monthYear}`);
    } else {
      return this.saveFile(workbook, `creditnoteList-${moment(startDate).format("D-M-YYYY")}-to-${moment(endDate).format("D-M-YYYY")}`);
    }
  }

}